import validate from 'validate.js';
const moment = require('moment');

const NOTFOUND = 'NOTFOUND';
const PATTERN_ISBN = /^978-7-((\d{2})-(\d{6})|(\d{3})-(\d{5})|(\d{4})-(\d{4})|(\d{5})-(\d{3}))-(\d)$/
const PATTERN_IDCARD = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
const PATTERN_MOBILE = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
// 这个应该没用 可空的话直接不require就行了
const PATTERN_MOBILE_NULL = /(^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$)|无$/
const PATTERN_PHONE = /(^(?:\d{3,4}-?)?\d{7,8}(?:-\d{1,6})?$)|无$/;
const PATTERN_URL = /(^((http|https)?:\/\/)?(([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}$)|无$/
// var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
//     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
//     '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
//     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
//     '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
//     '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

// const PATTERN_PHONE = /(^(0\d{2,3})?-?\d{7,8}$)|无$/;
const PATTERN_ZIP = /(^[0-9]{6})|无$/;
const DICT_XINGBIE = [{id: '1', name: '男'}, {id: '2', name: '女'}]
const DICT_ISZHENGSHU = [{id: '1', name: '有'}, {id: '2', name: '无'}]
const DICT_ISZIZHI = [{id: '1', name: '有'}, {id: '2', name: ''}, {id: '2', name: '无'}]

export function CONST() {
  return {
    PATTERN_ISBN,
    PATTERN_IDCARD,
    PATTERN_MOBILE,
    PATTERN_PHONE,
    PATTERN_URL,
  }
}

// validate.validators.custom = function(value, options, key, attributes) {
//   console.log(value);
//   console.log(options);
//   console.log(key);
//   console.log(attributes);
//   return "is totally wrong";
// };

// // Will log:
// //   - "some value"
// //   - "some options"
// //   - "foo"
// //   - {"foo": "some value"}
// validate({foo: "some value"}, {foo: {custom: "some options"}});
// => {foo: ["Foo is totally wrong"]}
// Before using it we must add the parse and format functions
// Here is a sample implementation using moment.js
validate.extend(validate.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  parse: function(value, options) {
    return +moment.utc(value);
  },
  // Input is a unix timestamp
  format: function(value, options) {
    console.debug(`format: [${value}]`, value, options)
    var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
    // return moment.utc(value).format(format);
    return moment(new value).format(format);
  }
});

function formatDate(value) {
  var format = "YYYY-MM-DD"
  // console.debug('formatDate: ', value, moment(value).format(format))
  return moment(value).format(format);
}

// 检查日期 没错的话顺便格式化一下
validate.validators.formatdate = function(value, options, key, attributes) {
  // console.debug('formatdate: ', key, value, options, attributes)
  // 空的话无所谓？ 非空用别的设定判断？
  if(validate.isEmpty(value)) return
  // 有错的话 回错误的数组 没错回undefined 所以true是有错
  if(validate({ formatdate: value }, { formatdate: { datetime: { dateOnly: true }}})) {
    return options.message
  }
  attributes[key] = formatDate(attributes[key])
};

// 可以直接用format
// validate.validators.isbn = function(value, options, key, attributes) {
//   // 格式
//   let pattern = /^978-7-((\d{2})-(\d{6})|(\d{3})-(\d{5})|(\d{4})-(\d{4})|(\d{5})-(\d{3}))-(\d)$/
//   if (!pattern.test(value)) {
//     return '请检查标准书号格式'
//   }
// };

validate.validators.biaozhushuhao = function(value, options, key, attributes) {
  if(validate.isEmpty(attributes.biaozhushuhao) && validate.isEmpty(attributes.tongyishuhao)){
    return '请输入标准书号或统一书号'
  }
  if(!validate.isEmpty(attributes.biaozhushuhao) && !validate.isEmpty(attributes.tongyishuhao)){
    return '标准书号或统一书号只能填写一个'
  }
  if (!validate.isEmpty(attributes.biaozhushuhao) && !PATTERN_ISBN.test(attributes.biaozhushuhao)) {
    return '标准书号格式错误'
  }
};

validate.validators.tongyishuhao = function(value, options, key, attributes) {
  if(validate.isEmpty(attributes.biaozhushuhao) && validate.isEmpty(attributes.tongyishuhao)){
    return '请输入标准书号或统一书号'
  }
  if(!validate.isEmpty(attributes.biaozhushuhao) && !validate.isEmpty(attributes.tongyishuhao)){
    return '标准书号或统一书号只能填写一个'
  }
};

validate.validators.years = function(value, options, key, attributes) {
  const { year1, year2 } = options
  if(!validate.contains([year1, year2], value * 1)){
    return '年份'
  }
};

validate.validators.isyinjin = function(value, options, key, attributes) {
  console.log('!!!!!!!!!!',value, options, key, attributes)
  const { dict } = options
  if (validate.isEmpty(value)) {
    return '是否引进版不能为空'
  }
  // 是
  if(value.trim() === '是'){
    const res = getKeyFromItems(attributes.yinjinqingkuangmingcheng, dict)
    if (res === NOTFOUND) {
      return '请按照手册填写引进情况'
    }
    attributes.isyinjin = 1
    attributes.yinjinqingkuangId = res
    // "ff8080816467fb6d0164683b6a4d01ba" 
    // "其他国家/地区"
    if (res === 'ff8080816467fb6d0164683b6a4d01ba') {
      if (validate.isEmpty(attributes.qtyinjinqingkuang)) {
        return `请填写其他引进情况`
      }
    } else {
      if (!validate.isEmpty(attributes.qtyinjinqingkuang)) {
        return `其他引进情况`
      }
    }
  // 否的时候 另外两项不能填
  } else if(value.trim() === '否'){
    if (!validate.isEmpty(attributes.yinjinqingkuangmingcheng)) {
      return '请确认引进情况' // [%{value}]
    }
    if (!validate.isEmpty(attributes.qtyinjinqingkuang)) {
      return `请填写其他引进情况`
    }
    attributes.isyinjin = 2
  } else {
    return '请按手册选择是否引进版'
  }
};
// 可能用不上了
validate.validators.yinjinqingkuang = function(value, options, key, attributes) {
  // var pbNum2 = (rule,val,callback) => {      // 标准书号
  console.debug('yinjinqingkuang: ', value, options, key, attributes)
  console.debug(`${attributes.isyinjin}: [${value}]`, !validate.isEmpty(value))
  const { dict } = options
  // 是
  if(attributes.isyinjin.trim() === '1'){
    const res = getKeyFromItems(value, dict)
    if (res === NOTFOUND) {
      return '请按照手册填写引进情况'
    }
    attributes.yinjinqingkuangId = res
  } else {
    if (!validate.isEmpty(value)) {
      return '请确认引进情况' // [%{value}]
    }
  }
};

validate.validators.leibie = function(value, options, key, attributes) {
  const { dict, message } = options
  const _dict = dict.map( d => {
    const _d = {...d}
    _d.name = d.name.split(' ')[0]
    return _d
  })
  const res = getKeyFromItems(value, _dict)
  if (res === NOTFOUND) {
    return `${message}`
  }
  attributes.leibieId = res
  const resName = getNameFromItems(attributes.leibieId, dict)
  attributes.leibiemingcheng = resName
};

// 中小学教材
validate.validators.iszxxjc = function(value, options, key, attributes) {
  const { dict, message } = options
  const _dict = dict.map( d => {
    const _d = {...d}
    _d.name = d.name.split(' ')[0]
    return _d
  })
  const res = getKeyFromItems(value?value:'NULL', _dict)
  if (res === NOTFOUND) {
    return `${message}`
  }
  attributes.iszxxjcId = res
  const resName = getNameFromItems(attributes.iszxxjcId, dict)
  attributes.iszxxjcmingcheng = resName
};

// 教辅
validate.validators.isjf = function(value, options, key, attributes) {
  // console.debug('isjf: ', value, options)
  const { dict, message } = options
  const _dict = dict.map( d => {
    const _d = {...d}
    _d.name = d.name.split(' ')[0]
    return _d
  })
  const res = getKeyFromItems(value?value:'NULL', _dict)
  if (res === NOTFOUND) {
    return `${message}`
  }
  attributes.isjfId = res
  const resName = getNameFromItems(attributes.isjfId, dict)
  attributes.isjfmingcheng = resName
};

// 再版重印
validate.validators.zaibancy = function(value, options, key, attributes) {
  // console.debug('zaibancy: ', value, options)
  const { dict, message } = options
  const _dict = dict.map( d => {
    const _d = {...d}
    _d.name = d.name.split(' ')[0]
    return _d
  })
  const res = getKeyFromItems(value?value:'NULL', _dict)
  if (res === NOTFOUND) {
    return `${message}`
  }
  attributes.zaibancyId = res
  const resName = getNameFromItems(attributes.zaibancyId, dict)
  attributes.zaibancymingcheng = resName
};

// 重点项目
validate.validators.inDictAndSetId = function(value, options, key, attributes) {
  // console.debug('inDictAndSetId: ', value, options)
  const { dict, message, setId, other } = options
  const res = getKeyFromItems(value, dict)
  if (res === NOTFOUND) {
    return `${message}`
  }
  // 如果需要setId
  if (setId) {
    attributes[setId] = res
  }
  // 如果有其他名称
  if (other) {
    const { id, name, key: otherKey, message: otherMessge } = other
    if (res === id) {
      if (validate.isEmpty(attributes[otherKey])) {
        return `${otherMessge}`
      }
    } else {
      if (!validate.isEmpty(attributes[otherKey])) {
        return `${otherMessge}`
      }
    }
  }
};

// 
validate.validators.inDictAndCheckOthers = function(value, options, key, attributes) {
  console.debug('inDictAndCheckOthers: ', value, options)
  const { dict, message, setId, others } = options
  const res = getKeyFromItems(value, dict)
  if (res === NOTFOUND) {
    return `${message}`
  }
  // 如果需要setId
  if (setId) {
    attributes[setId] = res
  }
  // 如果有其他名称
  if (others) {
    let ret, msgs
    const { ids, name, items } = others
    if (validate.contains(ids, res)) {
      ret = items.map(other => {
        const { key, options, message } = other
        // 有错的话 回错误的数组 没错回undefined 所以true是有错
        // return validate({ item: attributes[key] }, { item: options }, {fullMessages: false})
        let va = validate(attributes, { [key]: options }, {fullMessages: false})
        // console.debug('others: ', va, _.values(va))
        return _.values(va)
      })
      // console.debug('ret: ', ret)
      msgs = []
      _.forEach(ret, x => {
        // console.debug('x: ', x)
        msgs = _.concat(msgs, x)
      })
      // ret = _.compact(_.map(ret, 'item'))
      console.debug('others: ', msgs)
    } else {
      ret = items.map(other => {
        const { key, message } = other
        if(!validate.isEmpty(attributes[key])) return message
      })
      console.debug('no others: ', ret, _.compact(_.map(ret, 'item')), ids, res, validate.contains(ids, res))
      msgs = _.compact(ret)
    }
    // console.debug('msgs: ', msgs)
    // compact 是remove了废物项
    return msgs
  }
};

function getKeyFromItems(value, items) {
  // console.debug('getKeyFromItems: ', value, items)
  const item = _.find(items, {name: value})
  if (item) {
    return item.id
  }
  return NOTFOUND
}

function getNameFromItems(value, items) {
  // console.debug('getKeyFromItems: ', value, items)
  const item = _.find(items, {id: value})
  if (item) {
    return item.name
  }
  return ''
}

export function Material01(options) {
  const { d0001,} = options.dictionary
  console.log('d0001',d0001)
  const { year1, year2 } = options
  // console.debug('Material05: ', options, _.map(d0008.items, 'name'))
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))
  return {
    danwei: { presence: {message: '请输入单位名称'},},
    isbn: { presence: {message: '请输入现用ISBN前缀'}, 
      // format: { pattern: /\d{2,5}/, message: "现用ISBN前缀格式错误"}
    },
    wangzhi: { presence: {message: '请输入单位网址'}, format: { pattern: PATTERN_URL, message: "网址格式错误"}},
    leibiemingcheng: { presence: {message: '请输入单位类别'},
      inDictAndCheckOthers: {
        dict: d0001.items, setId: 'leibieId', message: '请选择单位类别',
      },
    },
    chenglrq: { presence: {allowEmpty: false, message: '请输入单位成立日期'}, formatdate: { message: '单位成立日期' }},
    djshijian: { presence: {allowEmpty: false, message: '请输入法人登记时间'}, formatdate: { message: '法人登记时间' }},
    dizhi: { presence: {allowEmpty: false, message: '请输入单位地址'},},
    youbian: { presence: {message: '请输入单位邮编'}, format: { pattern: PATTERN_ZIP, message: "单位邮编格式错误"}},
    faren: { presence: {allowEmpty: false, message: '请输入法定代表人姓名'},},
    farendf: { presence: {message: '请输入法定代表人办公室电话'}, format: { pattern: PATTERN_PHONE, message: "法定代表人办公室电话格式错误"}},
    farensj: {presence: {message: '请输入法定代表人办公手机号'},format: {pattern: PATTERN_MOBILE, message: "法定代表人办公手机号格式错误",}},
    sbdianhua: { presence: {message: '请输入社办电话'}, format: { pattern: PATTERN_PHONE, message: "社办电话格式错误"}},
    sbchuanzhen: { presence: {message: '请输入社办传真'}, format: { pattern: PATTERN_PHONE, message: "社办传真格式错误"}},
    zbdianhua: { presence: {message: '请输入总编室电话'}, format: { pattern: PATTERN_PHONE, message: "总编室电话格式错误"}},
    zbchuanzhen: { presence: {message: '请输入总编室传真'}, format: { pattern: PATTERN_PHONE, message: "总编室传真格式错误"}},
    chusfw: { presence: {allowEmpty: false, message: '请输入出书范围'},},
    zhigshu: { presence: {message: '请输入单位职工总数'}, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '职工总数错误' }},
    gaojizhichengshu: { presence: {message: '请输入单位职工高级职称人数'}, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '高级职称人数错误' }},
    zhongjizhichengshu: { presence: {message: '请输入单位职工中级职称人数'}, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '中级职称人数错误' }},
    neisjg: { presence: {allowEmpty: false, message: '请输入内设机构'},},
    zhubandw: { presence: {allowEmpty: false, message: '请输入主办单位'},},
    zbzzbm: { presence: {allowEmpty: false, message: '请输入主办单位承担管理职责的部门'},},
    zbdizhi: { presence: {allowEmpty: false, message: '请输入主办单位地址'},},
    zbyoubian: { presence: {message: '请输入主办单位邮编'}, format: { pattern: PATTERN_ZIP, message: "主办单位邮编格式错误"}},
    zhubanlianxiren: { presence: {allowEmpty: false, message: '请输入主办单位联系人'},},
    zhubandwzuoji: { presence: {message: '请输入主办单位联系人座机'}, format: { pattern: PATTERN_PHONE, message: "主办单位联系人座机格式错误"}},
    zhubanshouji: { presence: {message: '请输入主办单位联系人手机'},format: {pattern: PATTERN_MOBILE, message: "主办单位联系人手机格式错误",}},
    zgdanw: { presence: {allowEmpty: false, message: '请输入主管单位'},},
    zgzzbm: { presence: {allowEmpty: false, message: '请输入主管单位承担管理职责的部门'},},
    zgdizhi: { presence: {allowEmpty: false, message: '请输入主管单位地址'},},
    zgyoubian: { presence: {message: '请输入主管单位邮编'}, format: { pattern: PATTERN_ZIP, message: "主管单位邮编格式错误"}},
    zglxr: { presence: {allowEmpty: false, message: '请输入主管单位联系人'},},
    zglxrzuoji: { presence: {message: '请输入主管单位联系人座机'}, format: { pattern: PATTERN_PHONE, message: "主管单位联系人座机格式错误"}},
    zglxrdf: { presence: {message: '请输入主管单位联系人手机'}, format: {pattern: PATTERN_MOBILE, message: "主管单位联系人手机格式错误",}},
    gzfzr: { presence: {allowEmpty: false, message: '请输入出版单位年度核验工作负责人'},},
    gzfzrsj: { presence: {message: '请输入出版单位年度核验工作负责人电话'}, format: { pattern: PATTERN_PHONE, message: "出版单位年度核验工作负责人电格式错误"}},
    gzfzrdf: { presence: {message: '请输入出版单位年度核验工作负责人手机'}, format: {pattern: PATTERN_MOBILE, message: "入出版单位年度核验工作负责人手机格式错误",}},
  }
}

export function Material02(options) {
  const { d0002, d0003, d0004, d0005, d0013 } = options.dictionary
  console.debug('Material02: ', options, _.map(d0004.items, 'name'))
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))
  return {
    xingming: { presence: {allowEmpty: false, message: '请输入姓名'},}, 
    // xingbie: { presence: {message: '请输入性别'},}, 
    xingbie: { presence: {message: '请输入性别'},
      inDictAndCheckOthers: {
        dict: DICT_XINGBIE, setId: 'xingbie', message: '请选择性别',
      },
    }, 
    // pattern: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{4}$/
    shenfenzheng: { presence: {message: '请输入身份证号'},
      format: {
        pattern: PATTERN_IDCARD,
        flag: "i",
        message: "身份证格式",
      }
    }, 
    zhiwu: { presence: {allowEmpty: false, message: '请输入职务/职称'},},
    renzhisj: { presence: {allowEmpty: false, message: '请输入任职时间'},},
    zhenzhimmmingcheng: { presence: {message: '请输入政治面貌'},
      inDictAndSetId: {
        dict: d0003.items, setId: 'zhenzhimmId', message: '请选择政治面貌',
      },
    }, 
    wenhuamingcheng: { presence: {message: '请输入文化程度'},
      inDictAndSetId: {
        dict: d0004.items, setId: 'wenhuaId', message: '请选择文化程度',
      },
    },
    jibiemingcheng: { presence: {message: '请输入出版专业职称级别'},
      inDictAndCheckOthers: {
        dict: d0005.items, setId: 'jibieId', message: '请选择出版专业职称级别',
        others: {
          // ids: 'ff808081648886600164888c43bb0018', name: '暂无', 
          ids: _.map(_.filter(d0005.items, o => o.name !== '暂无'), 'id'), name: '暂无', 
          items: [
            { key: 'zhengshubh', message: '出版专业职业资格证书编号', 
              options: { presence: {allowEmpty: false, message: '请输入出版专业职业资格证书编号'},}},
          ]
        }
      },
    },
    iszhengshu: { presence: {message: '请输入是否获得岗位培训证书'},
      inDictAndCheckOthers: {
        dict: DICT_ISZHENGSHU, setId: 'iszhengshu', message: '是否获得岗位培训证书',
        others: {
          ids: ['1'], name: '有', 
          items: [
            { key: 'zhengshusj', message: '岗位培训证书获得时间', 
              options: { presence: { allowEmpty: false, message: '岗位培训证书获得时间'}, formatdate: { message: '岗位培训证书获得时间' }}},
          ]
        },
      },
    },
    shouji: { presence: {message: '请输入手机'},
      format: {
        pattern: PATTERN_MOBILE,
        flag: "i",
        message: "手机",
      }
    },
  }
}

export function Material03(options) {
  const { d0002, d0003, d0004, d0005, d0013 } = options.dictionary
  // console.debug('Material03: ', options, _.map(d0005.items, 'name'), _.keyBy(d0005.items, 'name'), _.mapValues(_.keyBy(d0005.items, 'name'), 'id'))
  // console.debug('Material03: ', options)
  return {
    xingming: { presence: { allowEmpty: false, message: '请输入姓名'},}, 
    // xingbie: { presence: {message: '请输入性别'},}, 
    xingbie: { presence: {message: '请输入性别'},
      inDictAndCheckOthers: {
        dict: DICT_XINGBIE, setId: 'xingbie', message: '请选择性别',
      },
    }, 
    // pattern: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{4}$/
    shenfenzheng: { presence: { allowEmpty: false, message: '请输入身份证号'},
      format: {
        pattern: PATTERN_IDCARD,
        flag: "i",
        message: "身份证格式错误",
      }
    }, 
    zhenzhimmmingcheng: { presence: {message: '请输入政治面貌'},
      inDictAndSetId: {
        dict: d0003.items, setId: 'zhenzhimmId', message: '请选择政治面貌',
      },
    }, 
    wenhuamingcheng: { presence: {message: '请输入文化程度'},
      inDictAndSetId: {
        dict: d0004.items, setId: 'wenhuaId', message: '请选择文化程度',
      },
    },
    zhuanye1mingcheng: { presence: {  allowEmpty: false, message: '请输入专业'},}, 
    // zhuanye1mingcheng: { presence: {message: '请输入专业'},
    //   inDictAndSetId: {
    //     dict: d0013.items, setId: 'xiangmuId', message: '请选择项目名称',
    //   },
    // }, 
    gangweimingcheng: { presence: {message: '请输入所在岗位'},
      inDictAndSetId: {
        dict: d0002.items, setId: 'gangweiId', message: '请选择所在岗位',
      },
    }, 
    zhiwu: { presence: { allowEmpty: false, message: '请输入职务/职称'},}, 
    jibiemingcheng: { presence: {message: '请输入出版专业职称级别'},
      inDictAndCheckOthers: {
        dict: d0005.items, setId: 'jibieId', message: '请选择出版专业职称级别',
        others: {
          // ids: 'ff808081648886600164888c43bb0018', name: '暂无', 
          ids: _.map(_.filter(d0005.items, o => o.name !== '暂无'), 'id'), name: '暂无', 
          items: [
            { key: 'zbzyzyzgzsbh', message: '出版专业职业资格证书编号', 
              options: { presence: {  allowEmpty: false, message: '请输入出版专业职业资格证书编号'},}},
          ]
        }
      },
    }, 
    // 要一起检查了？
    // zbzyzyzgzsbh: { presence: {message: '请输入出版专业职业资格证书编号'},}, 
    // zczrbjbh: { presence: {message: '请输入注册责任编辑编号'},}, 
    // yxDate: { presence: {message: '请输入注册有效期'},}, 
    iscscbwzz: { presence: {message: '请输入是否有辞书出版资质'},
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'iscscbwzz', message: '是否有辞书出版资质',
      },
    },
    isysbjlcbwcbzz: { presence: {message: '请输入是否有养生保健类出版物出版资质'},
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'isysbjlcbwcbzz', message: '是否有养生保健类出版物出版资质',
      },
    },
    isdtcbcbzz: { presence: {message: '请输入是否有地图出版资质'},
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'isdtcbcbzz', message: '是否有地图出版资质',
      },
    },
    iszxxjfcbzz: { presence: {message: '请输入是否有中小学教辅出版资质'},
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'iszxxjfcbzz', message: '是否有中小学教辅出版资质',
      },
    },
    iswlcbzz: { presence: {message: '请输入是否有网络出版资质'},
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'iswlcbzz', message: '是否有网络出版资质',
      },
    },
  }
}

export function Material04(options) {
  const { d0012 } = options.dictionary
  return {
    zyywsr: {
      presence: {message: '请输入主营业务收入'},
      numericality: { greaterThanOrEqualTo: 0, message: '主营业务收入', },
    },
    qtywsr: {
      presence: {message: '请输入其他业务收入'},
      numericality: { greaterThanOrEqualTo: 0, message: '其他业务收入', },
    },
    pzbzsh: {
      presence: {message: '请输入品种数(标准)'},
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '品种数(标准)', },
    },
    pztysh: {
      presence: {message: '请输入品种数(统一)'},
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '品种数(统一)', },
    },
    xsbzsh: {
      presence: {message: '请输入新书品种数(标准)'},
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '新书品种数(标准)', },
    },
    xstysh: {
      presence: {message: '请输入新书品种数(统一)'},
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '新书品种数(统一)', },
    },
    cypzbzsh: {
      presence: {message: '请输入重印品种数(标准)'},
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '重印品种数(标准)', },
    },
    cypztysh: {
      presence: {message: '请输入重印品种数(统一)'},
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '重印品种数(统一)', },
    },
    zongyinshu: {
      presence: {message: '请输入总印数'},
      numericality: { greaterThanOrEqualTo: 0, message: '总印数', },
    },
    zongyinzhang: {
      presence: {message: '请输入总印张'},
      numericality: { greaterThanOrEqualTo: 0, message: '总印张', },
    },
    chubanmayang: {
      presence: {message: '请输入定价总金额'},
      numericality: { greaterThanOrEqualTo: 0, message: '定价总金额', },
    },
    fahuomayang: {
      presence: {message: '请输入发货总金额'},
      numericality: { greaterThanOrEqualTo: 0, message: '发货总金额', },
    },
    xiaoshouzongce: {
      presence: {message: '请输入销售总册数'},
      numericality: { greaterThanOrEqualTo: 0, message: '销售总册数', },
    },
    xiaoshoumayang: {
      presence: {message: '请输入销售总金额'},
      numericality: { greaterThanOrEqualTo: 0, message: '销售总金额', },
    },
    xiaoshoushouru: {
      presence: {message: '请输入销售收入'},
      numericality: { greaterThanOrEqualTo: 0, message: '销售收入', },
    },
    qzszcbsr: {
      presence: {message: '请输入数字出版总额'},
      numericality: { greaterThanOrEqualTo: 0, message: '数字出版总额', },
    },
    szcblrze: {
      presence: {message: '请输入数字出版利润总额'},
      numericality: { number: true, message: '数字出版利润总额', },
    },
    tushulirun: {
      presence: {message: '请输入图书利润总额'},
      numericality: { number: true, message: '图书利润总额', },
    },
    pingjunlirun: {
      presence: {message: '请输入图书单品种平均利润'},
      numericality: { number: true, message: '图书单品种平均利润', },
    },
    kucunmayang: {
      presence: {message: '请输入库存总金额'},
      numericality: { greaterThanOrEqualTo: 0, message: '库存总金额', },
    },
    rjnsr: {
      presence: {message: '请输入人均年收入'},
      numericality: { greaterThanOrEqualTo: 0, message: '人均年收入', },
    },
  }
}

export function Material05(options) {
  const { d0006, d0007, d0008, d0009, d0014 } = options.dictionary
  const { year1, year2 } = options
  // console.debug('Material05: ', options, _.map(d0008.items, 'name'))
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))
  return {
    year: {
      years: { year1, year2, message: '年份' },
    },
    shuming: {
      presence: { allowEmpty: false, message: '请输入书名', fullMessages: false},
    },
    biaozhushuhao: {
      biaozhushuhao: true,
      // isbn: true,
      // format: { pattern: PATTERN_ISBN, message: "标准书号格式错误"}
    },
    tongyishuhao: {
      tongyishuhao: true,
    },
    zhebian: {
      presence: { allowEmpty: false, message: '请输入责编'},
    },
    yishen: {
      presence: { allowEmpty: false, message: '请输入初审'},
    },
    ershen: {
      presence: { allowEmpty: false, message: '请输入复审'},
    },
    sanshen: {
      presence: { allowEmpty: false, message: '请输入终审'},
    },
    zishu: {
      // validator: number1,
      presence: {message: '字数不能为空'},
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        message: '字数应为正整数',
      },
    },
    isyinjin: {
      isyinjin: {message: "是否为引进版", dict: d0014.items},
      // presence: true, //{message: '请选择是否为引进版'},
      // inclusion: {
      //   within: ['1', '2'],
      //   message: "是否为引进版"
      // }
    },
    // 上边一起check了
    // yinjinqingkuangmingcheng: {
    //   // yinjinqingkuang: true,
    //   yinjinqingkuang: {
    //     dict: d0014.items,
    //   }
    // },
    // qtyinjinqingkuang: {
    //   presence: {message: '请填写国家或地区'},
    // },
    leibiemingcheng: {
      leibie: {dict: d0006.items, message: '图书分类'},
    },
    iszxxjcmingcheng: {
      iszxxjc: {dict: d0007.items, message: '是否中小学教材'},
    },
    isjfmingcheng: {
      isjf: {dict: d0008.items, message: '是否中小学教辅'},
    },
    zaibancymingcheng: {
      zaibancy: {dict: d0009.items, message: '是否再版重印'},
    },
    dingjia: {
      presence: {message: '请输入定价'},
      // type: {type: 'number', message: '请确认定价'},
      numericality: {
        greaterThanOrEqualTo: 0,
        // lessThan: 100000,
        message: '请确认定价',
      },
    },
    yinshu: {
      presence: {message: '请输入印数'},
      // type: {type: 'number', message: '请确认印数'},
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        message: '印数应为正整数',
      },
    },
    // cbName: {
    //   presence: {message: '出版单位'},
    // },
  }
}

// 表7 表彰
export function Material06(options) {
  const { d0012 } = options.dictionary
  return {
    hjtime: { presence: { allowEmpty: false, message: '请选择时间'},},
    jiangxiangmingcheng: {
      inDictAndSetId: {
        dict: d0012.items, setId: 'jiangxiangId', message: '请选择表彰奖项',
        other: { id: '75', name: '其他按规定程序获得批准举办的省部级图书奖项', key: 'jxname', message: '表彰奖项(其他)' },
      },
    },
    hjtushu: { presence: { allowEmpty: false, message: '请输入表彰对象'},}, 
    banjiangdanwei: { presence: { allowEmpty: false, message: '请输入颁奖单位'},},
  }
}

// 表8 重点 07
export function Material07(options) {
  const { d0010 } = options.dictionary
  return {
    shuming: { presence: {allowEmpty: false, message: '请输入书名'},}, 
    xiangmumingcheng: {
      inDictAndSetId: {
        dict: d0010.items, setId: 'xiangmuId', message: '请选择项目名称',
        other: { id: '64', name: '其他', key: 'jxname', message: '项目名称(其他)' },
      },
    },
    zizhujine: { presence: {message: '请输入资助金额'},
      numericality: {
        greaterThanOrEqualTo: 0,
        // lessThan: 10000,
        message: '资助金额',
      },
    }, 
    wancqk: { presence: {allowEmpty: false, message: '请输入完成情况'},}, 
    remark: { presence: {allowEmpty: false, message: '请输入备注'},},
    // 项目里一起
    // jxname: { presence: {message: '请输入项目名称'},}, 
  }
}

// 表9 管理制度
// date
// https://github.com/ansman/validate.js/issues/129
export function Material08(options) {
  console.debug('Material08: ', options)
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))
  return {
    zhidu: { presence: {allowEmpty: false, message: '请输入制度名称'}, }, 
    zdtime: { presence: { allowEmpty: false, message: '请选择制定时间'}, formatdate: { message: '制定时间' }  },
    xdtime: { formatdate: { message: '修改时间' } },
    snwenhao: { presence: {allowEmpty: false, message: '请输入社内文号'},}, 
    zxqk: { presence: {allowEmpty: false, message: '请输入执行情况'},},
  }
}


// WEBPACK FOOTER //
// ./src/constraints.js